/**
 *
 *
 * @export
 * @param {*} val
 * @param {*} { type, max, min, toFixed = 2 }
 * @returns
 */
export default function formatVal(val = '', { maxLength = Number.MAX_SAFE_INTEGER, type, max = Number.MAX_SAFE_INTEGER, min = Number.MIN_SAFE_INTEGER, toFixed = 2 }) {
    if(val === '') return ''

    if (type === 'int') {
        val = (String(val)).trim()
        val = val.substr(0, maxLength)

        if(val !== '-') {
            val = parseInt(val)
            isNaN(val) && (val = '')
        }

        if(max !== Number.MAX_SAFE_INTEGER) {
            if(val > max) val = max
        }
        if(min != Number.MIN_SAFE_INTEGER) {
            if(val < min) val = min
        }
    } else if (type === 'float') {
        val = (String(val)).trim()
        if(/^\d+\.\d+$/.test(val)) {
            val = (+val).toFixed(toFixed)
            val = parseFloat(val)
        }

        isNaN(val) && (val = '')
        if(val > max) val = max
        if(val < min) val = min
    } else if (type === 'string') {
        val = val.substr(0, maxLength)
    }
    return String(val)
}